import React from 'react';
import About from './About'
import Landing from './Landing'
import Projects from './Projects'
import Contact from './Contact'

function App() {
  return (
    <div className="App">
      <Landing />
      <About />
      <Projects />
      <Contact />
    </div>
  );
}

export default App;
